export const erpApiRoutes = {
  employees: {
    list: 'employees',
    listAvailability: 'employees/availability',
    listAvailabilityForEmployee: 'employees/availability-for-employee',
    getByCurrentUser: 'employees/me',
    get: 'employees/:id',
    getByVersion: 'employees/:id/version',
    getVersionOptions: 'employees/:id/version-options',
    getSimilarVersionOptions: 'employees/:id/similar-version-options',
    options: 'employees/options',
    genderOptions: 'employees/gender-options',
    getSchedule: 'employees/:id/schedule',
    updateSchedule: 'employees/:id/schedule',
    delete: 'employees/:id',
    employeeProfile: 'employees/profile',
  },
  employeeData: {
    createOrUpdate: 'employee-data/create-or-update',
    createOrUpdatePersonalDetails:
      'employee-data/create-or-update-personal-details',
    createOrUpdateEmploymentInfo: 'employee-data/create-or-update-employment',
    getByProcessId: 'employee-data/process/:id/:taskId',
  },
  documentTemplates: {
    get: 'document-templates/:id',
    list: 'document-templates',
    create: 'document-templates',
    update: 'document-templates/:id',
    delete: 'document-templates/:id',
    options: 'document-templates/options',
    optionsByType: 'document-templates/:type/options',
    typesOptions: 'document-templates/type-options',
    getTypeVariables: 'document-templates/type-variables',
    getForAutoFill: 'document-templates/for-autofill',
  },
  jobTitles: {
    get: 'job-titles/:id',
    list: 'job-titles',
    all: 'job-titles/all',
    options: 'job-titles/options',
    create: 'job-titles',
    update: 'job-titles/:id',
    archive: 'job-titles/:id/archive',
    updateHierarchy: 'job-titles/hierarchy',
    delete: 'job-titles/:id',
  },
  departments: {
    get: 'departments/:id',
    list: 'departments',
    options: 'departments/options',
    create: 'departments',
    update: 'departments/:id',
    delete: 'departments/:id',
  },
  documents: {
    list: 'documents',
    listByEmployee: 'documents/by-employee',
    listForEmployee: 'documents/for-employee',
    getBreadcrumbs: 'documents/:id/breadcrumbs',
    getBreadcrumbsForEmployee: 'documents/:id/breadcrumbs-for-employee',
    downloadAsset: 'documents/:id/download',
    downloadAssetForEmployee: 'documents/:id/download-for-employee',
    rename: 'documents/:id/rename',
    documentsByProcess: 'documents/process',
  },
  tasks: {
    get: 'tasks/:id',
    list: 'tasks',
    listForUser: 'tasks/user',
    listForDocument: 'tasks/document',
    getSignAvailability: 'tasks/:id/sign-availability',
    signInitiate: 'tasks/:id/sign-initiate',
    sign: 'tasks/:id/sign',
    remind: 'tasks/:id/remind',
  },
  taskDocuments: {
    get: 'task-documents/:id',
    list: 'task-documents',
    getFile: 'task-documents/:id/file',
    updateDocumentAsRead: 'task-documents/:id/read',
  },
  timeOffs: {
    typesOptions: 'time-offs/type-options',
    statusOptions: 'time-offs/status-options',
    createOrUpdate: 'time-offs/create-or-update',
  },
  globalDocumentTemplates: {
    get: 'global-document-templates/:id',
    list: 'global-document-templates',
    create: 'global-document-templates',
    update: 'global-document-templates/:id',
    delete: 'global-document-templates/:id',
    typesOptions: 'global-document-templates/type-options',
    taskDocumentTypesOptions:
      'global-document-templates/task-document-type-options',
    getTypeVariables: 'global-document-templates/type-variables',
    getForAutoFill: 'global-document-templates/for-autofill',
    options: 'global-document-templates/options',
    optionsByType: 'global-document-templates/:type/options',
  },
  middleware: {
    openApp: 'middleware/open-app',
    getCompanyDetails: 'middleware/company-details',
    updateCompanyDetails: 'middleware/company-details',
    deleteApiKey: 'middleware/api-key/:id',
    getApiKeys: 'middleware/api-key',
    generateApiKey: 'middleware/api-key/generate',
  },
  globalDocumentTemplateSettings: {
    get: 'global-document-template-settings/:id',
    list: 'global-document-template-settings',
    update: 'global-document-template-settings/:id',
  },
  documentTemplateSettings: {
    get: 'document-template-settings/:id',
    list: 'document-template-settings',
    update: 'document-template-settings/:id',
  },
  globalProcessSettings: {
    get: 'global-process-settings/:id',
    getProcessTasks: 'global-process-settings/:id/process-tasks',
    options: 'global-process-settings/options',
    list: 'global-process-settings',
    create: 'global-process-settings',
    update: 'global-process-settings/:id',
    delete: 'global-process-settings/:id',
  },
  globalProcessTaskSettings: {
    get: 'global-process-task-settings/:id',
    getTypeOptions: 'global-process-task-settings/type-options',
    getAssigneeTypeOptions:
      'global-process-task-settings/assignee-type-options',
    getSignTypeOptions: 'global-process-task-settings/sign-type-options',
    getDocumentPreparationOptions:
      'global-process-task-settings/:globalProcessSettingsId/document-preparation-options',
    create: 'global-process-task-settings',
    update: 'global-process-task-settings/:id',
    updatePositions: 'global-process-task-settings/positions',
    delete: 'global-process-task-settings/:id',
  },
  globalProcessStageSettings: {
    get: 'global-process-stage-settings/:id',
    create: 'global-process-stage-settings',
    update: 'global-process-stage-settings/:id',
    delete: 'global-process-stage-settings/:id',
  },
  processSettings: {
    get: 'process-settings/:id',
    getProcessTasks: 'process-settings/:id/process-tasks',
    options: 'process-settings/options',
    validOptions: 'process-settings/valid-options',
    list: 'process-settings',
    create: 'process-settings',
    update: 'process-settings/:id',
    delete: 'process-settings/:id',
    isEmployeeSelectVisible: 'process-settings/visible-employee',
  },
  processTaskSettings: {
    get: 'process-task-settings/:id',
    getTypeOptions: 'process-task-settings/type-options',
    getAssigneeTypeOptions: 'process-task-settings/assignee-type-options',
    getDocumentPreparationOptions:
      'process-task-settings/:processSettingsId/document-preparation-options',
    create: 'process-task-settings',
    update: 'process-task-settings/:id',
    updatePositions: 'process-task-settings/positions',
    delete: 'process-task-settings/:id',
  },
  processStageSettings: {
    get: 'process-stage-settings/:id',
    create: 'process-stage-settings',
    update: 'process-stage-settings/:id',
    delete: 'process-stage-settings/:id',
  },
  processes: {
    list: 'processes',
    listByEmployee: 'processes/by-employee',
    employeeList: 'processes/employee-list',
    get: 'processes/:id',
    getByEmployee: 'processes/:id/by-employee',
    create: 'processes',
    delete: 'processes/:id',
    regenerate: 'processes/regenerate/:id',
  },
  processTaskDocuments: {
    createOrUpdate: 'process-task-documents/create-or-update',
    previewDocument: 'process-task-documents/preview',
  },
  processTaskSigns: {
    readFile: 'process-task-signs/read-file',
    initiateFileSign: 'process-task-signs/initiate-sign',
    initiateFileSignQualified: 'process-task-signs/initiate-sign-qualified',
    completeFileSign: 'process-task-signs/complete-sign',
    preview: 'process-task-signs/preview',
  },
  processTasks: {
    completeTask: 'process-tasks/complete',
  },
  confidentialityAgreement: {
    createOrUpdate: 'confidentiality-agreements/create-or-update',
  },
  businessTrips: {
    statusOptions: 'business-trips/status-options',
    createOrUpdate: 'business-trips/create-or-update',
  },
  medicalBooks: {
    createOrUpdate: 'medical-books/create-or-update',
  },
  workCapacityLevels: {
    createOrUpdate: 'work-capacity-levels/create-or-update',
    relatedPersonOptions: 'work-capacity-levels/related-person-options',
  },
  childBirthEntries: {
    createOrUpdate: 'child-birth-entries/create-or-update',
    typeOptions: 'child-birth-entries/type-options',
  },
  processPersonalDataAgreement: {
    createOrUpdate: 'process-personal-data-agreements/create-or-update',
  },
  employeeIdentifications: {
    typeOptions: 'employee-identifications/type-options',
    createOrUpdate: 'employee-identifications/create-or-update',
  },
  workTimeEvents: {
    getByWorkTime: 'work-time-events/by-work-time/:id',
    getMonthlyTypes: 'work-time-events/monthly-type-options',
    create: 'work-time-events',
    getBreakValidations: 'work-time-events/break-validations',
    updateByWorkTime: 'work-time-events/by-work-time/:id',
    deleteByWorkTime: 'work-time-events/by-work-time/:id/delete',
  },
  processInits: {
    list: 'process-inits',
    createOrUpdate: 'process-inits/create-or-update',
    delete: 'process-inits/:id',
  },
};
